import React from "react";
import styled from "@emotion/styled";
import parse from 'html-react-parser';
import { Accordion, Flex, CheckIcon, MinusIcon, Text, Label, Button } from 'src/components';
import { i18n, mediaQuery, openCallMeModal, useAppDispatch } from "src/common";
import { colors } from "src/theme";
import { Card } from "./card";

const CardStyle = styled(Card)({
  marginTop: '12px',
})

const CardStyle2 = styled(Card)({
  padding: '12px',

  [mediaQuery('mobile')]: {
    padding: '4px',
  },
})

const AccordionStyle = styled(Accordion)({
  padding: '4px'
})

const LabelStyle = styled(Label)({
  marginLeft: '8px',
})

const LabelStyle2 = styled(Label)({
  marginBottom: '8px',
  textAlign: 'center',
})

const TextStyle = styled(Text)({
  marginLeft: '8px',
})

const TextContentStyle = styled(Text)({
  marginLeft: '16px',
})

const ButtonStyle = styled(Button)({
  marginInline: '8px'
})

interface Coverage {
  label: string;
  description: string;
}

interface CoveragesCardProps {
  coverages?: Array<Coverage>;
  additionalCoverages?: Array<Coverage>;
  title?: React.ReactNode;
  isExpanded: boolean;
  bListExpand?: boolean;
  expandable?: boolean;
  callMeBtn?: boolean;
  className?: string;
}

export const CoveragesCard = ({ isExpanded, coverages, title, additionalCoverages, bListExpand, expandable = false, callMeBtn = false, className }: CoveragesCardProps) => {
  const dispatch = useAppDispatch();

  const sortOrder = [
    "B lista lijekova",
    "Iskaznica",
    "OTHERS", // Placeholder for items that are not specifically listed
    "Svi troškovi participacije su pokriveni neograničeno"
  ];

  // Sortiranje niza
  const sortedCoverages = coverages?.slice().sort((a, b) => {
    const indexA = sortOrder.indexOf(a.label);
    const indexB = sortOrder.indexOf(b.label);

    // Ako je jedan od indeksa -1, stavite ga na mesto "OTHERS"
    const adjustedIndexA = indexA === -1 ? sortOrder.indexOf("OTHERS") : indexA;
    const adjustedIndexB = indexB === -1 ? sortOrder.indexOf("OTHERS") : indexB;

    return adjustedIndexA - adjustedIndexB;
  });

  return (
    <Card radius={12} padding={10} background={colors.background6} className={className}>
      <Flex vertical gap={4}>
        {title && <LabelStyle2 type='medium'>{title}</LabelStyle2>}
        {sortedCoverages && sortedCoverages.map((coverage, index) => {
          const isBlistExpanded = bListExpand && coverage.label === 'B lista lijekova';
          return (
            <CardStyle2 radius={4} key={index}>
              <Accordion
                title={<TextStyle type='tiny' bold color={colors.text3}>{coverage.label}</TextStyle>}
                content={<TextContentStyle type='tiny' color={colors.text3}>{parse(coverage.description)}</TextContentStyle>}
                icon={<CheckIcon color={colors.success} />}
                expandable={expandable}
                expandIcon={expandable}
                open={isBlistExpanded || isExpanded}
              />
            </CardStyle2>)
        })}

        {(isExpanded && additionalCoverages && additionalCoverages.length > 0) &&
          <CardStyle radius={4} padding={4}>
            <Accordion
              title={<Flex gap={8}>
                <LabelStyle type='small' color={colors.primary}>{i18n.t('components.cards.coveragesCard.additionalCoverages')}</LabelStyle>
                <Text type='tiny' color={colors.text3}>{i18n.t('components.cards.coveragesCard.notPossibleOnline')}</Text>
              </Flex>}
              content={
                <Flex vertical gap={12}>
                  {additionalCoverages.map((coverage, index) => {
                    if (callMeBtn && ((index + 1) === additionalCoverages.length)) return (
                      <Flex align='center' gap={8} key={index}>
                        <AccordionStyle
                          title={<TextStyle type='tiny' bold color={colors.text3}>{coverage.label}</TextStyle>}
                          content={<Text type='tiny' color={colors.text3}>{parse(coverage.description)}</Text>}
                          icon={<MinusIcon color={colors.success} />}
                          expandable={expandable}
                          expandIcon={expandable}
                          open={true}
                          key={index}
                        />
                        <ButtonStyle btnType="outlinePrimary" size="small" text="Zatraži poziv" onClick={() => dispatch(openCallMeModal())} />
                      </Flex>
                    )
                    return (
                      <AccordionStyle
                        title={<TextStyle type='tiny' bold color={colors.text3}>{coverage.label}</TextStyle>}
                        content={<Text type='tiny' color={colors.text3}>{parse(coverage.description)}</Text>}
                        icon={<MinusIcon color={colors.success} />}
                        expandable={expandable}
                        expandIcon={expandable}
                        open={true}
                        key={index}
                      />)

                  })}
                </Flex>
              }
              open={true}
            />
          </CardStyle>}
      </Flex>
    </Card>)
}